/**
 * AllAll 图片：flux-kontext-max
 * 参数与 flux-kontext-pro / flux-pro-1.1-ultra / flux-schnell 一致
 */
import { buildBodyWithModel } from './utils'

export function buildBody(params) {
  return buildBodyWithModel('flux-kontext-max', params)
}
